import React from 'react';

import { KeyValue } from 'components/KeyValue';

import * as Types from 'types';

import { ConfirmPlaylistRemovalModal } from './ConfirmPlaylistRemovalModal';

type Props = {
  playlist: Types.Playlist;
  showRemove?: boolean;
  onRemove: () => void;
};

type State = {
  confirm: boolean;
};

export class PlaylistInfobar extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { confirm: false };

    this.onRemovePlaylistClick = this.onRemovePlaylistClick.bind(this);
    this.hideConfirmDialog = this.hideConfirmDialog.bind(this);
  }

  onRemovePlaylistClick(event: React.MouseEvent) {
    event.preventDefault();
    this.setState({ confirm: true });
  }

  hideConfirmDialog() {
    this.setState({ confirm: false });
  }

  calculateTotalTime(playlist: Types.Playlist) {
    const totalSeconds = playlist.items.reduce((memo, playlistArtwork) => {
      // @TODO
      memo += 30;
      return memo;
    }, 0);
    return this.formatDuration(totalSeconds);
  }

  addZero(number: number) {
    return number < 10 ? `0${number}` : `${number}`;
  }

  formatDuration(totalSeconds: number) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
    const seconds = totalSeconds - hours * 3600 - minutes * 60;

    return (
      (hours ? this.addZero(hours) + ':' : '') +
      (this.addZero(minutes) + ':') +
      this.addZero(seconds)
    );
  }

  render() {
    const { playlist } = this.props;
    const count = playlist ? playlist.items.length : 0;

    return (
      <div className='playlist__infobar'>
        <KeyValue keyLabel='Artworks'>{count}</KeyValue>
        <KeyValue keyLabel='Total Time'>{this.calculateTotalTime(playlist)}</KeyValue>
        {this.props.showRemove && (
          <a
            href='#'
            className='key-value key-value--vault key-value--vault-danger key-value--inline link-border'
            onClick={this.onRemovePlaylistClick}
          >
            Delete
          </a>
        )}
        {this.state.confirm && (
          <ConfirmPlaylistRemovalModal
            onConfirm={this.props.onRemove}
            onRequestClose={this.hideConfirmDialog}
          />
        )}
      </div>
    );
  }
}
